import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpHeaders, HttpClient} from '@angular/common/http';
import {ApiService} from './api.service';
import {Service} from "@core/shared/models/service";
import {plainToClass} from "class-transformer";
import { SocietyService } from "@core/shared/models/society-service";
import {map} from "rxjs/operators";
import {Recipient} from "@core/shared/models/recipient";
import {IdentityVerification} from '@core/shared/models/identity-verification';

@Injectable({
    providedIn: 'root'
})
export class ServiceService {

    constructor(
        private _apiService: ApiService,
        private _httpClient: HttpClient,
    ) {}

    public createRecipientItemAPI(data: object, societyId: number): Observable<Recipient> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        return this._httpClient.post<Recipient>(`${this._apiService.getApiUrl(false, true)}/societies/${societyId}/legalDocuments/recipient`, data, {
            headers: headers
        });
    }

    public getRecipientItemAPI(societyId: number): Observable<Recipient> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        return this._httpClient.get<Recipient>(`${this._apiService.getApiUrl(false, true)}/societies/${societyId}/legalDocuments/recipient`, {
            headers: headers
        });
    }

    public getIdentityVerificationItemAPI(society: number): Observable<IdentityVerification> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        return this._httpClient.get<IdentityVerification>(`${this._apiService.getApiUrl(false, true)}/societies/${society}/identity/verification`, {
            headers: headers
        });
    }

    public createIdentityVerificationItemAPI(society: number): Observable<IdentityVerification> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        return this._httpClient.post<IdentityVerification>(`${this._apiService.getApiUrl(false, true)}/societies/${society}/identity/verification`, null, {
            headers: headers
        });
    }

    public getItemsAPI(params?: string[]): Observable<Service[]> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        let url: string = `${this._apiService.getApiUrl(false, true)}/services`;

        params = params || [];

        params.push('disablePagination=1');

        params.push('sort[position]=ASC');

        if (params.length > 0) {

            url = `${url}?${params.join('&')}`;
        }

        return this._httpClient.get<Service[]>(url, {
            headers: headers
        }).pipe(
            map((items: object[]): Service[] => {

                return items.map((item: object): Service => {

                    return plainToClass(Service, item);
                });
            })
        );
    }

    public getItemsServiceBySocietyWithoutPagination(id: number, params?: string[]): Observable<SocietyService[]> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        let url: string = `${this._apiService.getApiUrl(false, true)}/societies/${id}/services`;

        params = params || [];

        params.push('disablePagination=1');

        if (params.length > 0) {
            url = `${url}?${params.join('&')}`;
        }

        return this._httpClient.get<SocietyService[]>(url,{
            headers: headers
        }).pipe(
            map((items: object[]): SocietyService[] => {

                return items.map((item: object): SocietyService => {

                    return plainToClass(SocietyService, item);
                })
            })
        );
    }

    public getItemAPI(id: number): Observable<Service> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        let url: string = `${this._apiService.getApiUrl(false, true)}/services/${id}`;

        return this._httpClient.get<Service>(url, {
            headers: headers
        }).pipe(
            map((item: object): Service => {

                return plainToClass(Service, item);
            })
        );
    }

    public createSocietyServiceItemAPI(data: object, societyId: number): Observable<SocietyService> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        return this._httpClient.post<SocietyService>(`${this._apiService.getApiUrl(false, true)}/societies/${societyId}/services`, data, {
            headers: headers
        });
    }

    public cancelDeleteSocietyServiceItemAPI(id: number): Observable<SocietyService> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        return this._httpClient.get<any>(`${this._apiService.getApiUrl(false, true)}/societies/services/${id}/delete/cancel`, {
            headers
        })
        .pipe(
            map((item: object): SocietyService => {

                return plainToClass(SocietyService, item);
            })
        );
    }

    public summarySocietyServiceItemAPI(data: object, societyId: number): Observable<SocietyService> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        return this._httpClient.post<SocietyService>(`${this._apiService.getApiUrl(false, true)}/societies/${societyId}/services/summary`, data, {
            headers: headers
        });
    }

    public deleteSocietyServiceItemAPI(id: number): Observable<void> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        return this._httpClient.delete<any>(`${this._apiService.getApiUrl(false, true)}/societies/services/${id}`, {
            headers
        });
    }

    public getSocietyServiceItemAPI(id: number): Observable<SocietyService> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        let url: string = `${this._apiService.getApiUrl(false, true)}/societies/services/${id}`;

        return this._httpClient.get<SocietyService>(url,{
            headers: headers
        }).pipe(
            map((item: object): SocietyService => {

                return plainToClass(SocietyService, item);
            })
        );
    }
}
